import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { PartnersTunaService } from '../../contexts/partners/partners-tuna.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-enter-partner',
  templateUrl: './enter-partner.component.html',
  styleUrls: ['./enter-partner.component.scss']
})
export class EnterPartnerComponent implements OnInit {

  partner: string;
  invalidPartner = false;
  marketplacePartners: any;
  selectedTab: number;
  tabs = {
    MARKETPLACES: 0,
    OWN: 1
  }

  constructor(private toastr: ToastrService,
    private translateService: TranslateService,
    private titleService: Title,
    private partnerService: PartnersTunaService) { }

  ngOnInit() {
    this.selectedTab = this.tabs.MARKETPLACES;
    this.translateService.use("pt-br");
    this.titleService.setTitle('Console • Tuna');

    this.partnerService.getMarketplaces().subscribe({
      next: response => {

        this.marketplacePartners = response;
        this.marketplacePartners.forEach(element => {
          element.img = element.key.replace(' ', '').replace('-','').toLowerCase();
        });
      },
      error: e => console.error(e),
    });
  }

  continueWithPartner(partner: any) {
    if (!partner || !partner.key) {
      this.toastr.error(this.translateService.instant('enter.error'));
    } else {
      window.location.href = '/' + partner.key;
    }
  }

  continue() {
    if (!this.partner) {
      this.toastr.error(this.translateService.instant('enter.error'));
    } else {
      const partner = this.partner.toLowerCase();
      this.partnerService.check(partner).subscribe(
        (response) => {
          if (response) {
            window.location.href = '/' + partner;
          } else {
            this.invalidPartner = true;
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  stringToSlug(str) {
    str = str.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();

    // remove accents
    var from = "àáäâãèéëêìíïîòóöôõùúüûñç·/_,:;";
    var to = "aaaaaeeeeiiiiooooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    str = str
      .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
      .replace(/\s+/g, "-") // collapse whitespace and replace by -
      .replace(/-+/g, "-"); // collapse dashes

    this.partner = str;
  }

  changeTab(tabIndex: number) {
    this.selectedTab = tabIndex;
  }
}
